import React from 'react';
import styled from 'styled-components';
import { LazyPicture } from '@catalogo/theme-lazy-picture';
import { formatPrice } from '@catalogo/core-helpers/price';
import checkmark from '@catalogo/ui-americanas-desktop-svg/checkmark.svg';
import { IProductMain } from '../helpers/interfaces';

export const ProductMain: React.FC<IProductMain> = props => {
  const { mainPayment, mainProduct } = props;

  return (
    <Container>
      <ImageBox>
        <LazyPicture sources={{ desktop: { src: mainProduct?.image } }} alt={`foto do ${mainProduct?.name}`} />
      </ImageBox>
      <div>
        <ProductName>{mainProduct?.name}</ProductName>
        <ProductPrice>R$ {formatPrice(mainPayment?.price)}</ProductPrice>
        <MainProduct>
          <CheckUI /> <Text>produto atual</Text>
        </MainProduct>
      </div>
    </Container>
  );
};

const Container = styled.div`
  width: 140px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

const ImageBox = styled.div`
  width: 56px;
  height: 53px;
  margin: 0px auto 8px auto;
`;

const ProductName = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.grey.dark};
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const ProductPrice = styled.p`
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.grey.darker};
`;

const MainProduct = styled.p`
  display: flex;
  margin-top: 6px;
  align-items: center;
`;

const CheckUI = styled(checkmark)`
  fill: ${({ theme }) => theme.primaryColor};
`;

const Text = styled.span`
  font-size: 14px;
  font-weight: 400;
  font-style: italic;
`;

export default ProductMain;
